import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import AlbumCover from './AlbumCover';
import { albums } from '../data/albums';
import { HomeIcon } from './icons';
import logo from '../assets/logo/armagedify.png';

export default function Sidebar({ open, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      {open && <div className="sidebar-backdrop" onClick={onClose} aria-hidden="true" />}
      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <div className="brand">
          <img className="brand-mark" src={logo} alt="" aria-hidden="true" />
          <div className="brand-name">ARMAGEDIFY</div>
        </div>

        <nav className="nav" aria-label="Primary">
          <NavLink
            to="/"
            end
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={onClose}
          >
            <HomeIcon />
            <span>Αρχική</span>
          </NavLink>
        </nav>

        <div>
          <div className="nav-section-label">Η ΤΡΙΛΟΓΙΑ</div>
          <div className="library">
            {albums.map((a) => {
              const active = location.pathname === `/album/${a.id}`;
              return (
                <div
                  key={a.id}
                  className={`library-item ${active ? 'active' : ''}`}
                  onClick={() => { navigate(`/album/${a.id}`); onClose?.(); }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate(`/album/${a.id}`); onClose?.(); } }}
                >
                  <AlbumCover album={a} className="library-thumb" />
                  <div className="library-meta">
                    <span className="library-title">{a.title}</span>
                    <span className="library-artist">{a.artist}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </aside>
    </>
  );
}
